import fetchApi from "./fetch";

export type MpSyncWatermarkDto = {
  marketplace: string;
  kind: "reserved" | "warehouse" | "remnant_1c" | "send" | string;
  asOf: string;
  finishedAt: string;
  rowsChanged: number;
  rowsTotal: number;
  stats?: Record<string, unknown> | null;
};

export type MpSyncWatermarkLogDto = MpSyncWatermarkDto & {
  id: number;
};

export type MpSyncWatermarkHistoryDto = {
  since: string;
  hours: number;
  article?: string | null;
  limit?: number;
  items: MpSyncWatermarkLogDto[];
};

export const getMpSyncWatermarks = async (
  article?: string
): Promise<MpSyncWatermarkDto[]> => {
  const q = article?.trim()
    ? `?article=${encodeURIComponent(article.trim())}`
    : "";
  const res = await fetchApi(`/api/mp-sync-watermarks${q}`);
  if (!res.ok) throw new Error("watermarks failed");
  return res.json();
};

export const getMpSyncWatermarkHistory = async (
  hours = 24,
  article?: string
): Promise<MpSyncWatermarkHistoryDto> => {
  const params = new URLSearchParams({ hours: String(hours) });
  const a = article?.trim();
  if (a) params.set("article", a);
  const res = await fetchApi(
    `/api/mp-sync-watermarks/history?${params.toString()}`
  );
  if (!res.ok) throw new Error("watermark history failed");
  return res.json();
};

export const getMpSyncWatermarkLog = async (
  id: number
): Promise<MpSyncWatermarkLogDto> => {
  const res = await fetchApi(`/api/mp-sync-watermarks/logs/${id}`);
  if (!res.ok) throw new Error("watermark log failed");
  return res.json();
};
